
<template>
  <div id="content">
    <section id="user">
      <div class="input_list">
        <ul>
          <li>
              <span class="list_line item_title text_right">
                <label>業種：</label>
              </span>
              <span class="list_line">
                <label>{{corpTypeLabel}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>所属部署：</label>
              </span>
              <span class="list_line">
                <label>{{userForm.corpDept}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>氏名：</label>
              </span>
              <span class="list_line">
                <label>{{userForm.userLastName}} {{userForm.userFirstName}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>氏名（カナ）：</label>
              </span>
              <span class="list_line">
                <label>{{userForm.userLastNameKana}} {{userForm.userFirstNameKana}}</label>
              </span>
          </li>
          <li v-if="!isEdit">
              <span class="list_line item_title text_right">
                <label>メールアドレス：</label>
              </span>
              <span class="list_line">
                <label>{{userForm.email}}</label>
              </span>
          </li>
          <li v-if="!isEdit">
              <span class="list_line item_title text_right">
                <label>パスワード：</label>
              </span>
              <span class="list_line">
                <label>********</label>
              </span>
          </li>
          <li v-if="!isEdit">
              <span class="list_line item_title text_right">
                <label>mm/styleをどこで知りましたか？：</label>
              </span>
              <span class="list_line">
                <label>{{infosrcLabel}}</label>
              </span>
          </li>
          <li v-if="false">
              <span class="list_line item_title text_right">
                <label>招待コード：</label>
              </span>
              <span class="list_line">
                <label>{{userForm.inviteCode}}</label>
              </span>
          </li>
          <li>
              <span class="list_line item_title text_right">
                <label>メールマガジンの受信：</label>
              </span>
              <span class="list_line">
                <label>{{recvInfoLabel}}</label>
              </span>
          </li>
          <li>
            <label class="list_head">※自動メールにて返信しますので、「@domans.co.jp」からのメールを受信許可に設定してください。</label>
          </li>
        </ul>
      </div>
    </section>
  </div>
</template>
<script>
import {CORP_TYPE, INFO_SRC} from '../../constants/TypeEc'
// Module

export default {
  name: 'UserConfirm',
  components: {
  },
  props: {
    userForm: Object,
    isEdit: Boolean
  },
  data () {
    return {
    }
  },
  computed: {
    corpTypeLabel: function () {
      if (this.userForm.corpType === undefined || this.userForm.corpType === '') return ''
      return Object.keys(CORP_TYPE)
        .map(e => CORP_TYPE[e])
        .find(e => e.code === this.userForm.corpType)
        .label
    },
    infosrcLabel: function () {
      if (!this.userForm.infosrc) return ''
      return Object.keys(INFO_SRC)
        .map(e => INFO_SRC[e])
        .find(e => e.code === this.userForm.infosrc)
        .label
    },
    recvInfoLabel: function () {
      if (this.userForm.recvInfo === true) {
        return '受け取る'
      } else {
        return '受け取らない'
      }
    }
  },
  methods: {
  },
  created () {
  }
}
</script>
<style src="../../css/style.scss" lang="scss" scoped></style>
<style src="../../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/user/UserConfirm.vue